import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FingerDevicesService {

  constructor(private http: HttpClient) {

   }

     GetDeviceAttendanceConfigrationColumnsdropdown():Observable<any>{
    return this.http.get(`${environment.apiRoot}/api/AttendanceDevice/GetDropDown/DeviceAttendanceConfigrationColumns`);
  }

   GetDeviceAttendancesdropdown():Observable<any>{
    return this.http.get(`${environment.apiRoot}/api/AttendanceDevice/GetDropDown/Devices`);
  }
    GetfingerPrintDeviceTypedropdown():Observable<any>{
    return this.http.get(`${environment.apiRoot}/api/AttendanceDevice/GetDropDown/fingerPrintDeviceType`);
  }



    GetEmpAttendanceDeviceCVsdropdown():Observable<any>{
    return this.http.get(`${environment.apiRoot}/api/AttendanceDevice/GetDropDown/EmpAttendanceDeviceCVs`);
  }


  GetEmpAttendanceTypedropdown():Observable<any>{
    return this.http.get(`${environment.apiRoot}/api/AttendanceDevice/GetDropDown/EmpAttendanceType`);
  }

  CreateAttendanceDevice(data: any): Observable<any> {
    return this.http.post(`${environment.apiRoot}/api/AttendanceDevice/Add`, data);
  }
  importFingerServices(data: any): Observable<any> {
    return this.http.post(`${environment.apiRoot}/api/Attending_Leaving/RequestAttendingLeavingFromDevice`, data);
  }
  getDurationWorkSystemDropDown():Observable<any>{
    return this.http.get(`${environment.apiRoot}/api/DurationWorkSystem/GetDropDown`);
  }
  saveAttendanceData(data:any):Observable<any>{
    return this.http.post(`${environment.apiRoot}/api/Attending_Leaving/AddList`, data);
  }

  AddBulk(data:any){
     return this.http.post(`${environment.apiRoot}/api/Attending_Leaving/AddBulk`, data);
  }

}
